import Information from './Information'
import Statement from './Statement'
import Setting from './Setting'

const VCloud = {
    Information,
    Statement,
    Setting,
}

export default VCloud
